import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Visible consent line shown under auth / profile-creation actions.
 * `action` completes the sentence: "By {action}, you agree to our …".
 */
const ConsentNote = ({ action = 'continuing', className = '' }) => (
  <p className={`text-sm leading-5 text-white text-center ${className}`}>
    By {action}, you agree to our{' '}
    <Link to="/terms" className="underline hover:text-primary" style={{ textUnderlinePosition: 'from-font' }}>Terms of Service</Link>,{' '}
    <Link to="/privacy" className="underline hover:text-primary" style={{ textUnderlinePosition: 'from-font' }}>Privacy Policy</Link>, and{' '}
    <Link to="/cancellation-policy" className="underline hover:text-primary" style={{ textUnderlinePosition: 'from-font' }}>Cancellation Policy</Link>.
    {' '}This includes using your psychological profile to generate compatibility reports.
  </p>
);

export default ConsentNote;
